// Kingston, Jamaica is fixed UTC-5 year-round (no DST observed) — shared by
// AmberScanner, InfoTab, and TradingViewAlertsTab so every clock in the UI agrees.
export const toJamaica = (d) => {
  if (!d) return null;
  const date = (d instanceof Date) ? d : new Date(d);
  const utc = date.getTime() + (date.getTimezoneOffset() * 60000);
  return new Date(utc + (3600000 * -5));
};

export const formatJaTime = (d) => {
  const ja = toJamaica(d);
  if (!ja) return "";
  return ja.toLocaleTimeString("en-US", { hour12: true, hour: "2-digit", minute: "2-digit", second: "2-digit" });
};

export const formatJaDate = (d) => {
  const ja = toJamaica(d);
  if (!ja) return "";
  return ja.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const formatJaFull = (d) => {
  if (!d) return "";
  return `${formatJaDate(d)} ${formatJaTime(d)} (Jamaica)`;
};

// Calendar-boundary helpers — return a real UTC epoch-ms usable against trade
// timestamps (epoch ms, timezone-independent). toJamaica() pre-compensates for the
// browser's own offset so its LOCAL getters (not UTC getters) read as Jamaica
// wall-clock — see toJamaica() above. Jamaica midnight = 05:00 UTC (UTC-5, no DST).
export const jamaicaDayStartMs = (d = new Date()) => {
  const ja = toJamaica(d);
  return Date.UTC(ja.getFullYear(), ja.getMonth(), ja.getDate()) + 5 * 3600000;
};

export const jamaicaWeekStartMs = (d = new Date()) => {
  const ja = toJamaica(d);
  const dow = ja.getDay(); // 0 = Sunday, Jamaica wall-clock
  return Date.UTC(ja.getFullYear(), ja.getMonth(), ja.getDate() - dow) + 5 * 3600000;
};

export const jamaicaMonthStartMs = (d = new Date()) => {
  const ja = toJamaica(d);
  return Date.UTC(ja.getFullYear(), ja.getMonth(), 1) + 5 * 3600000;
};
